export default class Accordion {
  constructor(selector) {
    const triggers = document.querySelectorAll(
      selector ? selector : '.accordion-trigger',
    )

    if (!triggers) return
    this.onToggle = null

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.accordion-trigger')

      if (trigger) {
        e.preventDefault()

        // Check if trigger has a data-group attribute
        const group = trigger.getAttribute('data-group')
        if (group) {
          // Remove active class from the currently active accordion in the same group
          const activeInGroup = document.querySelector(
            `.accordion-trigger[data-group="${group}"].is-active`,
          )
          if (activeInGroup && activeInGroup !== trigger) {
            activeInGroup.classList.remove('is-active')

            // Hide the submenu of the previously active accordion
            const activeSubmenu = activeInGroup.getAttribute('data-submenu')
            if (activeSubmenu) {
              const submenuElement = document.querySelector(
                `.accordion-body[data-submenu="${activeSubmenu}"]`,
              )
              if (submenuElement && submenuElement !== activeInGroup) {
                submenuElement.classList.add('is-hidden')
              }
            }
          }
        }

        trigger.classList.toggle('is-active')

        // Handle submenu visibility if trigger is part of a group
        if (group) {
          const submenuId = trigger.getAttribute('data-submenu')
          if (submenuId) {
            const submenuElement = document.querySelector(
              `.accordion-body[data-submenu="${submenuId}"]`,
            )
            if (submenuElement && submenuElement !== trigger) {
              if (trigger.classList.contains('is-active')) {
                submenuElement.classList.remove('is-hidden')
              } else {
                submenuElement.classList.add('is-hidden')
              }
            }
          }
        }
        if (this.onToggle) this.onToggle.call()
      }
    })
  }
}
